import { IconProps } from './types'

export const MissingRegistryIcon = ({ size = 14, color = 'currentColor', id, ...props }: IconProps) => (
  <svg id={id} style={{ width: size, height: size, flexShrink: 0 }} viewBox='0 0 14 14' fill='none' {...props}>
    <path
      d='M12.25 4.375V12.25C12.25 12.4821 12.1578 12.7046 11.9937 12.8687C11.8296 13.0328 11.6071 13.125 11.375 13.125H2.625C2.39294 13.125 2.17038 13.0328 2.00628 12.8687C1.84219 12.7046 1.75 12.4821 1.75 12.25V1.75C1.75 1.51794 1.84219 1.29538 2.00628 1.13128C2.17038 0.967187 2.39294 0.875 2.625 0.875H8.75L12.25 4.375Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.75 0.875V4.375H12.25'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
